<template>
  <div class="silent-padding" @click="stopPropagation">
    <slot />
  </div>
</template>

<script>
export default {
  methods: {
    stopPropagation(event) {
      event.stopPropagation();
    }
  }
};
</script>

<style lang="scss" scoped>
.silent-padding {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 4px 6px 10px;
}
</style>

